import React, { ReactNode } from 'react'
import { Space } from 'antd'
import { useTheme, useThemeColors } from '../../ThemeContext'

interface PageHeaderProps {
	title: string
	subtitle?: string
	icon: ReactNode
	extra?: ReactNode
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, extra }) => {
	const { isDarkMode } = useTheme()
	const themeColors = useThemeColors()
	const { primary, text, textSecondary } = themeColors

	return (
		<div
			style={{
				background: themeColors.bg,
				borderBottom: `1px solid ${themeColors.border}`,
				padding: '14px 24px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				flexWrap: 'wrap',
				gap: 12,
			}}
		>
			<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
				<div
					style={{
						width: 48,
						height: 48,
						borderRadius: 10,
						background: isDarkMode ? `${primary}15` : primary,
						color: isDarkMode ? primary : '#fff',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexShrink: 0,
					}}
				>
					<span style={{ fontSize: 24, display: 'flex' }}>{icon}</span>
				</div>
				<div>
					<div
						style={{
							fontSize: 20,
							fontWeight: 700,
							color: text,
							lineHeight: '1.2',
						}}
					>
						{title}
					</div>
					{subtitle && (
						<div style={{ fontSize: 12, color: textSecondary, marginTop: 2 }}>
							{subtitle}
						</div>
					)}
				</div>
			</div>
			{extra && <Space size={8}>{extra}</Space>}
		</div>
	)
}


export default PageHeader
